import { render, staticRenderFns } from "./applyForwallet.vue?vue&type=template&id=5f04999a&scoped=true"
import script from "./applyForwallet.vue?vue&type=script&lang=js"
export * from "./applyForwallet.vue?vue&type=script&lang=js"
import style0 from "./applyForwallet.vue?vue&type=style&index=0&id=5f04999a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f04999a",
  null
  
)

export default component.exports